import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box } from "@/components/layout/flexbox";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { CoachingHeader } from "@/components/pieces/coaching/CoachingHeader";
import { AcceptingClients } from "@/components/pieces/coaching/CoachingSettings/AcceptingClients";
import { AvailabilityRelatedSettings } from "@/components/pieces/coaching/CoachingSettings/AvailabilityRelatedSettings";
import {
  LIGHTEST_BACKGROUND,
  SIDE_NAV_WIDTH,
  SITE_NAME,
  STANDARD_APP_MAX_WIDTH,
} from "@/css/constants";

export function AvailabilityPage() {
  return (
    <Authenticate requireCoach={true} maxWidth="100%" layout="dashboard">
      <>
        <SEOHead
          title={`Availability - ${SITE_NAME}`}
          description="Control your calendar, working hours, and more."
          canonicalPath="/availability"
        />
        <Nav />
        <Box ml={[0, 0, SIDE_NAV_WIDTH]}>
          <CoachingHeader selectedTab="availability" />
          <Box pb={6} bg={LIGHTEST_BACKGROUND}>
            <Box
              className="container"
              maxWidth={STANDARD_APP_MAX_WIDTH}
              m="0 auto"
              px={[3, 24]}
            >
              <Box width={1} mt={4}>
                <AcceptingClients />
                <AvailabilityRelatedSettings />
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    </Authenticate>
  );
}
